import { mapActions, mapGetters } from "vuex";

export const relanceMixin = {
  computed: {
    ...mapGetters({
      relances: "relance/list/items",
      relancesIsLoading: "relance/list/isLoading",
      sendRelanceIsLoading: "relance/send/isLoading",
      relanceCreateIsLoading: "relance/create/isLoading",
      typeRelancesIsLoading: "typeRelance/list/isLoading",
      typeRelances: "typeRelance/list/items",
    }),
  },
  methods: {
    ...mapActions({
      sendRelance: "relance/send/send",
      getRelances: "relance/list/getItems",
      getTypeRelances: "typeRelance/list/getItems",
      createRelance: "relance/create/create",
    }),
  },
};
